export default "__VITE_PUBLIC_ASSET__5442682f__"